

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { addNewQuestionLocal, addNewQuestions } from "../../../features/aiControl/aiControlSlice"
import AIQuestionItemAdd from "../../aiControl/AIQuestionItemAdd"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            
            .question-list{
                border: 2px solid ${({theme}) => theme.mainBorderColor};
                width: 100%;
                border-radius: 10px;
                margin-bottom: 20px;
                height: calc(100% - 80px);

                .add-btn{
                    width: 100%;
                    background-color: ${({theme}) => theme.mainBorderColor};
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items:center;
                    font-size: 3.4rem;
                    color: #fff;
                }
            }

            .btn-container{
                width: 100%;
                display: flex;
                gap: 20px;
            }
        }
    }
`
const AddAIQuestionModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const { lockScroll, unlockScroll } = useScrollLock();

    const {questionList, aiQuestionGroupData} = useSelector(state => state.aiControl)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {

        const list = questionList.map((item)=> {
            const {id, ...others} = item
            return others
        }) 

        const data = {
            titleId: aiQuestionGroupData.id,
            aidefaultMesssages: list
        }
        dispatch(addNewQuestions(data))
    }

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            <div className="question-list">
                {
                    questionList.map((item, i) => (
                        <AIQuestionItemAdd item={item} order={i+1} isItLast={i+1 === questionList.length}/>
                    ))
                }
                <button className="add-btn" onClick={()=>dispatch(addNewQuestionLocal())}>+</button>
            </div>
            <div className="btn-container">
                <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={handleSubmit}>Tamamla</Btn>
                <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddAIQuestionModal